import { useState, useEffect, useRef } from 'react';

/**
 * Hook for lazy loading content when it comes into viewport
 * @param {Object} options - Intersection observer options
 * @returns {Object} - { ref, isVisible, shouldLoad }
 */
export function useLazyLoad(options = {}) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setShouldLoad(true);
          // Once we've decided to load, stop observing
          observer.unobserve(element);
        }
      },
      {
        rootMargin: '100px', // Start loading 100px before element is visible
        threshold: 0.1,
        ...options
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps

  return { ref, isVisible, shouldLoad };
}